<script>

  import {API_COMPANY} from '../../common/api'

  export default {
    name: 'CompanyAdd',
    data() {
      return {
        companyAddForm: {
          name: '',
          phone: '',
          admin_name: '',
          admin_mobile: '',
          price: '',
          tax: '',
          address: '',
          number_pre: '',
          user_table: '',
          start_date: '',
          end_date: '',
        },
        rules: {
          name: [
            {required: true, message: '公司名称不能为空', trigger: 'blur'}
          ],
          phone: [
            {required: true, message: '公司电话不能为空', trigger: 'blur'}
          ],
          admin_name: [
            {required: true, message: '厂长姓名不能为空', trigger: 'blur'}
          ],
          admin_mobile: [
            {required: true, message: '厂长电话不能为空', trigger: 'blur'}
          ],
          price: [
            {required: true, message: '水费不能为空', trigger: 'blur'}
          ],
          tax: [
            {required: true, message: '税费不能为空', trigger: 'blur'}
          ],
          number_pre: [
            {required: true, message: '用户前缀不能为空', trigger: 'blur'}
          ],
          user_table: [
            {required: true, message: '用户表名不能为空', trigger: 'blur'}
          ],
          start_date: [
            {required: true, message: '开始日期不能为空', trigger: 'blur'}
          ],
          end_date: [
            {required: true, message: '结束日期不能为空', trigger: 'blur'}
          ],
        },
        dialogVisible: false
      }
    },
    create() {
      console.log(`进入了新增公司页`);
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            let params = this.companyAddForm;
            this.$http.POST(API_COMPANY, params,
              res => {
                this.loading = false;
                this.$emit('addCompanySuccess')
              }, err => {
                this.loading = false;
                this.$message.error(err.msg)
              })
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    }
  }
</script>

<template>
  <div>
    <el-form ref="companyAddForm" :model="companyAddForm" :rules="rules" size="small" @submit.native.prevent
             label-width="100px">
      <el-form-item label="公司名称" prop="name">
        <el-input v-model="companyAddForm.name" placeholder="请输入公司名称" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="公司电话" prop="phone">
        <el-input v-model="companyAddForm.phone" placeholder="请输入公司电话" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="厂长" prop="admin_name">
        <el-input v-model="companyAddForm.admin_name" placeholder="请输入厂长姓名" clearable
                  class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="admin_mobile">
        <el-input v-model="companyAddForm.admin_mobile" placeholder="请输入厂长手机号" clearable
                  class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="水费" prop="price">
        <el-input type="number" v-model="companyAddForm.price" placeholder="请输入水费" clearable
                  class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="税费" prop="tax">
        <el-input type="number" v-model="companyAddForm.tax" placeholder="请输入税费" clearable
                  class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="companyAddForm.address" placeholder="请输入地址" clearable
                  class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="用户前缀" prop="number_pre">
        <el-input v-model="companyAddForm.number_pre" placeholder="请输入用户前缀" clearable
                  class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="用户表名" prop="user_table">
        <el-input v-model="companyAddForm.user_table" placeholder="请输入用户表名" clearable
                  class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="开始日期" prop="start_date">
        <el-date-picker
          v-model="companyAddForm.start_date"
          type="date"
          placeholder="选择开始日期" style="width: 350px;">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="end_date">
        <el-date-picker
          v-model="companyAddForm.end_date"
          type="date"
          placeholder="选择结束日期" style="width: 350px;">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="resetForm('companyAddForm')" size="small">重 置</el-button>
        <el-button type="primary" @click="submitForm('companyAddForm')" size="small">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>

  @import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/company/CompanyAdd.vue